export default __webpack_public_path__ + "static/media/discord-logo.5de04f93.png";